import type { HTMLAttributes } from 'react';
import { cn } from '@virginexperiencedays/tailwind';

export const Article = ({ children, className }: HTMLAttributes<HTMLElement>) => {
  return (
    <article className={cn('m-auto flex max-w-[688px] flex-col', className)}>{children}</article>
  );
};
